/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Ref_N2Inputs */

const en_minifier_ref_n2 = /** @type {(inputs: Minifier_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minified. 41.7 percent smaller than the baseline.`)
};

const ko_minifier_ref_n2 = /** @type {(inputs: Minifier_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`압축본입니다. 기준값보다 41.7퍼센트 작습니다.`)
};

const ja_minifier_ref_n2 = /** @type {(inputs: Minifier_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圧縮版です。基準値より 41.7 パーセント小さいです。`)
};

/**
* | output |
* | --- |
* | "Minified. 41.7 percent smaller than the baseline." |
*
* @param {Minifier_Ref_N2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_ref_n2 = /** @type {((inputs?: Minifier_Ref_N2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Ref_N2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_ref_n2(inputs)
	if (locale === "ko") return ko_minifier_ref_n2(inputs)
	return ja_minifier_ref_n2(inputs)
});